package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import dev.lingvo.shared.screenshots.doc.DesignLimits
import dev.lingvo.shared.screenshots.doc.FitSpec
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.ds.LNumberField
import dev.lingvo.site.ds.LSectionHeading
import dev.lingvo.site.ds.Space
import dev.lingvo.site.i18n.t

/** Bounds match the codec and keep the floor below the requested maximum at the input boundary. */
@Composable
internal fun CaptionSizes(fit: FitSpec, canWrite: Boolean, onChange: (Double, Double) -> Unit) {
    Column(Modifier.gap(Space.MD)) {
        LSectionHeading(t("app.projects.slug.screenshots.caption_sizes.caption", "Caption sizes"), description = t("app.projects.slug.screenshots.caption_sizes.keep_every_caption_above_its_legibility", "Keep every caption above its legibility floor."))
        if (canWrite) {
            LNumberField(fit.maxSize, { onChange(it, fit.floorSize) }, label = t("app.projects.slug.screenshots.caption_sizes.maximum", "Maximum"),
                unit = "px", decimals = 1, step = 0.5, min = fit.floorSize, max = DesignLimits.MAX_FONT_SIZE)
            LNumberField(fit.floorSize, { onChange(fit.maxSize, it) }, label = t("app.projects.slug.screenshots.caption_sizes.floor", "Legibility floor"),
                unit = "px", decimals = 1, step = 0.5, min = DesignLimits.MIN_FONT_SIZE, max = fit.maxSize)
        } else LMuted("${fit.floorSize}–${fit.maxSize} px") // i18n-ignore: numeric range and unit symbol.
    }
}
